export enum KnownRunAsUsername {
    LocalSystem = 'LocalSystem',
}
